/* Ora Frames — Pixel Love Story Poster customizer.
   Drives window.OraPixelStory (ora-pixelstory-engine.js). Every choice is saved on the order:
   readable lines (Scene, Name 1, Name 2, Title, Milestone 1–4, Frame) plus the full design, hidden. */
(function () {
  'use strict';

  var SIZES = { A4: '21 × 29.7 cm', A3: '29.7 × 42 cm', A2: '42 × 59.4 cm' };
  var PREVIEW_MAX_PX = 700; // the preview is never big enough to print from

  function sizeKey(title) { if (/digital/i.test(title || '')) return 'A2'; var m = /\bA[2-4]\b/i.exec(title || ''); return m ? m[0].toUpperCase() : 'A2'; }

  function moneyFormatter(format) {
    format = format || ('{' + '{amount}' + '}');
    return function (cents) {
      var whole = Math.floor(cents / 100), frac = String(cents % 100).padStart(2, '0');
      var grouped = function (sep) { return String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
        if (k === 'amount_no_decimals') return grouped(',');
        if (k === 'amount_with_comma_separator') return grouped('.') + (frac === '00' ? '' : ',' + frac);
        if (k === 'amount_no_decimals_with_comma_separator') return grouped('.');
        return grouped(',') + (frac === '00' ? '' : '.' + frac);
      });
    };
  }

  function encodeChunks(data) {
    var raw = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
    var chunks = {};
    (raw.match(/.{1,245}/g) || []).forEach(function (c, i) { chunks['_poster_data' + (i === 0 ? '' : '_' + i)] = c; });
    return chunks;
  }

  // Digital-file variant: no frame, delivered as a print-ready file on WhatsApp or email
  function isDigital(state) { return !!(state.variant && /digital/i.test(state.variant.title)); }
  function markDigital(properties) {
    properties['Frame'] = 'None (digital file)';
    properties['Format'] = 'Digital file (print-ready, sent on WhatsApp or email)';
    properties['_frame'] = 'none';
    properties['_format'] = 'digital';
  }

  // "Share this design": a link that opens this designer with the same design (read by applyPreset)
  function shareDesign(state, btn) {
    var s = {};
    Object.keys(state).forEach(function (k) {
      var v = state[k];
      if (k === 'variant' || k === 'kind' || v === null || typeof v === 'object' || typeof v === 'function') return;
      s[k] = v;
    });
    var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(s)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var url = window.location.origin + window.location.pathname + '?design=' + b64;
    var text = (btn && btn.dataset.shareText) || '';
    if (navigator.share) {
      navigator.share({ title: document.title, text: text, url: url }).catch(function () {});
    } else {
      window.open('https://wa.me/?text=' + encodeURIComponent((text ? text + ' ' : '') + url), '_blank', 'noopener');
    }
  }

  // "Start with this design" links (gift guide pages): ?design=<base64url JSON> fills the designer in.
  // Only settings this designer has are taken, choices must match one of its options, text is capped.
  function applyPreset(state, form) {
    var raw = new URLSearchParams(window.location.search).get('design');
    if (!raw) return false;
    var d;
    try { d = JSON.parse(decodeURIComponent(escape(atob(raw.replace(/-/g, '+').replace(/_/g, '/'))))); } catch (e) { return false; }
    if (!d || typeof d !== 'object') return false;
    var used = false;
    Object.keys(d).forEach(function (k) {
      if (k === 'variant' || k === 'kind' || !Object.prototype.hasOwnProperty.call(state, k)) return;
      var cur = state[k], v = d[k], field = form.elements[k];
      if (field && (field.type === 'radio' || field.tagName === 'SELECT' || (field.length && field[0] && field[0].type === 'radio'))) {
        var ok = Array.prototype.some.call(field.length !== undefined && field.tagName !== 'SELECT' ? field : (field.options || [field]), function (o) { return o.value === String(v); });
        if (!ok) return;
        v = String(v);
      } else if (typeof cur === 'number') {
        v = parseFloat(v); if (!isFinite(v)) return;
      } else if (typeof cur === 'boolean') {
        v = !!v;
      } else if (typeof cur === 'string') {
        if (typeof v !== 'string' && typeof v !== 'number') return;
        v = String(v).slice(0, field && field.maxLength > 0 ? field.maxLength : 120);
        if (k === 'accentColor' && v && !/^#[0-9a-f]{6}$/i.test(v)) return;
        if ((k === 'date') && v && !/^\d{4}-\d{2}-\d{2}$/.test(v)) return;
        if ((k === 'time') && v && !/^\d{2}:\d{2}$/.test(v)) return;
      } else return;
      state[k] = v; used = true;
    });
    return used;
  }

  function init(root) {
    var P = window.OraPixelStory;
    var form = root.querySelector('[data-px-form]');
    var canvas = root.querySelector('[data-px-canvas]');
    var wrap = root.querySelector('[data-px-wrap]');
    var frameEl = root.querySelector('[data-px-frame]');
    var variants = JSON.parse(root.querySelector('[data-px-variants]').textContent);
    var strings = JSON.parse(root.querySelector('[data-px-strings]').textContent);
    var defaults = JSON.parse(root.querySelector('[data-px-defaults]').textContent);
    var money = moneyFormatter(root.dataset.moneyFormat);
    // Price: the original price struck through when the variant is discounted (compare-at price), and a "Save" tag
    function priceHtml(v, noSave) {
      if (!(v.compare_at_price > v.price)) return money(v.price);
      var html = '<s class="ora-was">' + money(v.compare_at_price) + '</s> ' + money(v.price);
      return noSave ? html : html + ' <span class="ora-save">' + escapeHtml(strings.save || 'Save') + ' ' + money(v.compare_at_price - v.price) + '</span>';
    }
    // The "Digital file: ~~Rs 990~~ Rs 470" offer under the price: only while a framed size is selected
    function syncOffer() {
      var offer = root.querySelector('[data-digital-offer]');
      if (offer) offer.hidden = !state.variant || state.variant.requires_shipping === false;
    }
    function escapeHtml(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    var sceneBase = root.dataset.sceneBase;
    var iconTpl = root.querySelector('[data-px-icons]');
    var sceneName = function (key) { var s = P.SCENES.filter(function (x) { return x.key === key; })[0]; return s ? s.name : key; };
    var iconName = function (key) { return (P.ICON_LABELS[key] || key).replace(/\s*\(.*\)$/, ''); };

    var params = new URLSearchParams(window.location.search);
    var state = Object.assign({ scene: 'scene-09', frameColor: 'black', count: '3' }, defaults, {
      variant: variants.find(function (v) { return String(v.id) === params.get('variant'); }) || null
    });

    function milestones() {
      var out = [];
      for (var i = 1; i <= +state.count; i++) out.push({ label: state['label' + i] || '', year: state['year' + i] || '', icon: state['icon' + i] || 'heart' });
      return out;
    }
    function design() { return { title: state.title, name1: state.name1, name2: state.name2, milestones: milestones() }; }

    // ---------- scene images ----------
    var images = {};
    function sceneImage(key) {
      if (!images[key]) {
        var img = new Image();
        img.onload = function () { draw(); };
        img.src = sceneBase + key + '.png';
        images[key] = img;
      }
      return images[key].complete && images[key].naturalWidth ? images[key] : null;
    }

    // ---------- preview ----------
    var pending = false, lastImg = null;
    function draw() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var w = Math.min(PREVIEW_MAX_PX, Math.round((wrap.clientWidth || 500) * (window.devicePixelRatio || 1)));
        var h = Math.round(w * P.PAGE_H / P.PAGE_W);
        if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; }
        var img = sceneImage(state.scene) || lastImg; // keep the old scene until the new one has loaded
        if (img && img === images[state.scene]) lastImg = img;
        P.draw(canvas, design(), img);
      });
    }
    if (window.ResizeObserver) new ResizeObserver(draw).observe(wrap);

    // ---------- form <-> state ----------
    function syncForm() {
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || !(el.name in state)) return;
        var v = state[el.name];
        if (el.type === 'radio') el.checked = (el.value === String(v));
        else if (el.value !== v) el.value = v == null ? '' : v;
      });
      form.querySelectorAll('input[name="variant"]').forEach(function (r) { r.checked = !!state.variant && String(state.variant.id) === r.value; });
      update();
    }

    function setIconPreview(i) {
      var box = root.querySelector('[data-px-milestone="' + i + '"] [data-px-icon-preview]');
      var src = iconTpl.content.querySelector('[data-icon="' + state['icon' + i] + '"] svg');
      box.innerHTML = src ? src.outerHTML : '';
    }

    function update() {
      root.querySelectorAll('[data-px-milestone]').forEach(function (row) {
        var i = +row.dataset.pxMilestone;
        row.hidden = i > +state.count;
        row.querySelectorAll('input, select').forEach(function (el) { el.disabled = row.hidden; });
        setIconPreview(i);
      });
      root.querySelector('[data-px-scene-name]').textContent = sceneName(state.scene);
      root.querySelector('[data-px-frame-name]').textContent = { black: 'Black', white: 'White' }[state.frameColor] || '';
      var priceEl = root.querySelector('[data-px-price]'), titleEl = root.querySelector('[data-px-variant-title]'), btnEl = root.querySelector('[data-px-btn-label]');
      if (state.variant) {
        priceEl.innerHTML = priceHtml(state.variant); syncOffer();
        titleEl.textContent = '· ' + state.variant.title;
        btnEl.innerHTML = escapeHtml(strings.addLabel) + ' · ' + priceHtml(state.variant, true);
      } else {
        priceEl.innerHTML = strings.fromPrice; syncOffer(); titleEl.textContent = ''; btnEl.textContent = strings.chooseSize;
      }
      var key = state.variant ? sizeKey(state.variant.title) : 'A2';
      frameEl.className = 'ora-frame ora-sm__frame ora-frame--' + state.frameColor;
      if (isDigital(state)) frameEl.className = 'ora-frame ora-sm__frame ora-frame--none';
      root.classList.toggle('is-digital', isDigital(state));
      frameEl.dataset.size = key;
      var note = root.querySelector('[data-px-size-note]');
      if (note) note.textContent = 'Shown at ' + key + ' · ' + SIZES[key];
    }

    function onChange(e) {
      var el = e.target;
      if (!el.name) return;
      if (el.name === 'variant') {
        state.variant = variants.find(function (v) { return String(v.id) === el.value; }) || state.variant;
        root.querySelector('[data-px-sizes]').classList.remove('is-attention');
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variant.id);
        window.history.replaceState({}, '', url.toString());
      } else if (el.name in state) {
        state[el.name] = /^year\d$/.test(el.name) ? el.value.replace(/\D/g, '').slice(0, 4) : el.value;
        if (/^year\d$/.test(el.name) && el.value !== state[el.name]) el.value = state[el.name];
      }
      if (el.getAttribute('aria-invalid') === 'true' && validField(el)) el.removeAttribute('aria-invalid');
      hideError(); update(); draw();
    }
    form.addEventListener('input', onChange);
    form.addEventListener('change', onChange);

    // ---------- validation ----------
    function validField(el) {
      if (el.disabled) return true;
      var v = el.value.trim();
      if (/^year\d$/.test(el.name)) return /^\d{4}$/.test(v);
      if (el.required || /^label\d$/.test(el.name)) return v.length > 0;
      return true;
    }
    function validate() {
      var bad = [];
      Array.prototype.forEach.call(form.querySelectorAll('input[type="text"]'), function (el) {
        if (validField(el)) el.removeAttribute('aria-invalid'); else { el.setAttribute('aria-invalid', 'true'); bad.push(el); }
      });
      return bad;
    }

    var errorEl = root.querySelector('[data-px-error]');
    function showError(m) { errorEl.textContent = m; errorEl.hidden = false; }
    function hideError() { errorEl.hidden = true; }
    var loader = root.querySelector('[data-px-loader]');
    window.addEventListener('pageshow', function (e) { if (e.persisted) loader.hidden = true; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      hideError();
      var bad = validate();
      if (bad.length) { showError(strings.needFields); bad[0].focus(); return; }
      if (!state.variant) {
        var sizes = root.querySelector('[data-px-sizes]');
        showError(strings.needSize);
        sizes.classList.add('is-attention');
        sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var first = sizes.querySelector('input:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
        return;
      }
      loader.hidden = false;
      var size = sizeKey(state.variant.title);
      var ms = milestones();
      var full = Object.assign(design(), { kind: 'pixel-story', scene: state.scene, sceneName: sceneName(state.scene), frameColor: state.frameColor,
        size: size, variantId: state.variant.id, version: 1, release: '2026.11.01', generatedAt: new Date().toISOString() });
      var properties = {
        'Scene': sceneName(state.scene),
        'Name 1': state.name1.trim(),
        'Name 2': state.name2.trim(),
        'Title': state.title.trim()
      };
      ms.forEach(function (m, i) { properties['Milestone ' + (i + 1)] = m.label.trim() + ' · ' + m.year + ' · ' + iconName(m.icon); });
      properties['Frame'] = { black: 'Black', white: 'White' }[state.frameColor];
      Object.assign(properties, {
        '_poster_type': 'pixel-story', '_scene': state.scene, '_size': size, '_frame': state.frameColor,
        '_variant_id': String(state.variant.id), '_generated_at': full.generatedAt
      }, encodeChunks(full));
      // Snapshot of this design for the cart (kept in the customer's browser only)
      var designId = window.OraDesignThumb ? window.OraDesignThumb.save(canvas) : '';
      if (designId) properties['_design_id'] = designId;
      if (isDigital(state)) markDigital(properties);

      fetch(root.dataset.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: state.variant.id, quantity: 1, properties: properties }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || strings.cartError);
          window.location.href = root.dataset.cartUrl;
        })
        .catch(function (err) { loader.hidden = true; showError(err.message || strings.cartError); });
    });

    applyPreset(state, form);
    var shareBtn = root.querySelector('[data-share-design]');
    if (shareBtn) shareBtn.addEventListener('click', function () { shareDesign(state, shareBtn); });
    // ---------- start ----------
    syncForm();
    P.loadFonts().then(draw);
    draw();
    root.oraPixelStory = { state: state, draw: draw, design: design };
  }

  function boot() {
    if (!window.OraPixelStory) return setTimeout(boot, 50);
    document.querySelectorAll('[data-ora-pixelstory]').forEach(function (root) { if (!root.oraPixelStory) init(root); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
